import { FC, Fragment, PropsWithChildren, ReactNode } from 'react';
import { Divider, Flex } from '@servicetitan/anvil2';
import * as Styles from './chat-layout.module.less';
import classNames from 'classnames';

interface ChatLayoutProps {
    header?: ReactNode;
    subHeader?: ReactNode;
    footer?: ReactNode;
}

export const ChatLayout: FC<PropsWithChildren<ChatLayoutProps>> = ({
    header,
    subHeader,
    footer,
    children,
}) => {
    return (
        <Flex className={classNames('chat-layout', Styles.chatLayout)} direction="column">
            {header && (
                <div className={classNames('chat-header', Styles.chatLayoutHeader)}>{header}</div>
            )}
            {subHeader && (
                <div className={classNames('chat-sub-header', Styles.chatLayoutSubHeader)}>
                    {subHeader}
                </div>
            )}
            <div
                id="messages-container"
                className={classNames('chat-content', Styles.chatLayoutContent)}
            >
                {children}
            </div>
            {footer && (
                <Fragment>
                    <Divider />
                    <div className={classNames('chat-footer', Styles.chatLayoutFooter)}>
                        {footer}
                    </div>
                </Fragment>
            )}
        </Flex>
    );
};
